import React, { useEffect, useState } from "react";
import "./currentEvent.css";
import BadgeImage from "../../Components/Badges"
import minusVector from "../../../Asset/Events/minus-vector.svg";
import plusVector from "../../../Asset/Events/plus-vector.svg";
import calendarVector from "../../../Asset/Events/calendar-vector.svg";
import locationVector from "../../../Asset/Events/location-vector.svg";
import timeVector from "../../../Asset/Events/time-vector.svg";
import linkVector from "../../../Asset/Events/link-vector.svg";
import partnerVector from "../../../Asset/Events/partner-vector.svg"

import AccordianFaq from "../EventComponents/AccordianFaq";
import ShowSponsors from "../EventComponents/ShowSponsors";
import MoreEvents from "./moreEvents";
import Axios from "axios";
import { format } from "date-fns";
import { useParams } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { Link, useLocation } from "react-router-dom";
import { marked } from "marked";
import ReactMarkdown from 'react-markdown'
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import Header from '../../Header/header';
import Footer from '../../Footer/footer';
import axios from "axios";
import { formatPrice } from "../../utils/price";




const OrderPaymentEventPage = () => {
  // Initialize state to store event data
  const [eventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(true); // Track loading state
  const [error, setError] = useState(null); // Track error state
  const [formattedDates, setFormattedDates] = useState({});
  let { eventId } = useParams();
  const [moreEvents, setMoreEvent] = useState(null);
  const [imageUrlSquare, setImageUrlSquare] = useState("");
  const [imageUrlWide, setImageUrlWide] = useState("");

  // Use States for payment status view
  const [topBar, setTopBar] = useState(true);

  // Payment flow states
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [step, setStep] = useState(1); // 1: mobile, 2: otp, 3: processing
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [loader, setLoader] = useState(false);
  const [message, setMessage] = useState("");
  const [secondMessage, setSecondMessage] = useState("");
  const [showRetry, setShowRetry] = useState(false);
  const [disableVerifyBtn, setDisableVerifyBtn] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  
  // Get suborderId from URL params
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const suborderId = searchParams.get('suborderId');
  
  // User profile variables
  let FirstName, MobileNumber, EmailAddress;

  // Payment flow functions
  const sendOtp = async () => {
    try {
      setLoader(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/login/OTP`, {
        mobile_number: mobile,
        country_code: "+91"
      });
      setStep(2);
      setMessage("OTP sent successfully");
    } catch (error) {
      console.error(error);
      setMessage("Error sending OTP");
    } finally {
      setLoader(false);
    }
  };

  const verifyOtp = async () => {
    try {
      setLoader(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/login/verifyOTP`, {
        mobile_number: mobile,
        otp: otp,
      });
      console.log('response is:', response.data);
        const access_token = response.data.AccessToken;
        localStorage.setItem("access_token", access_token);
        setMessage("Login successful");
        fetchUserProfile(access_token, mobile);
        checkOrderCompletion(access_token, response.data.UserId);
        setDisableVerifyBtn(true);
        setMessage('')
      
    } catch (error) {
      console.error(error);
      setMessage("Error verifying OTP");
      if (error.response && error.response.status === 400) {
        console.log(error.response)
        if (error.response.data.detail === "OTP has expired") {
          setMessage("OTP has expired. Retry again.");
          setShowRetry(true);
        }
        if(error.response.data.detail === "Invalid OTP") {
          setMessage("Invalid OTP");
          setShowRetry(true);
        }
      }
    } finally {
      setLoader(false);
    }
  };

  const fetchUserProfile = async (access_token, mobile) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/users/?mobile_number=${mobile}&limit=10&offset=0`, {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("User profile response:", response.data.users[0]);
      FirstName = response.data.users[0].FirstName;
      MobileNumber = response.data.users[0].MobileNumber;
      EmailAddress = response.data.users[0].EmailAddress;
      setUserProfile(response.data.users[0]);
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const checkOrderCompletion = async (access_token, id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/payments/${suborderId}/status`,
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
          },
        }
      );
      console.log("Order completion status:", response.data);

      if (response.data.UserId !== id) {
        setSecondMessage("You are unauthorized for this payment. Use correct mobile number to proceed to payment!");
        setMessage("");
        setShowRetry(true);
        return;
      } else {
        if (response.data.PaymentCompleted === true) {
          setSecondMessage("Your Payment for this order is already completed.");
        } else {
          setSecondMessage("Your Payment is not completed yet. Proceeding to checkout...");
          handleCheckout(access_token);
        }
      }
    } catch (error) {
      console.error("Error in checking order completion:", error);
      setSecondMessage("Error in checking the order payment status.");
    }
  };

  const handleCheckout = async (access_token) => {
    setLoader(true);
    try {
      const checkoutResponse = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/checkout/?sub_order_id=${suborderId}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      const { RazorpayOrderId, FiatAmount } = checkoutResponse.data;
      console.log("mobile number:", MobileNumber);
      console.log("email:", EmailAddress);
      console.log('name:', FirstName);
      
      handleRazorpayPayment(RazorpayOrderId, FiatAmount);
    } catch (error) {
      console.error("Error during checkout process:", error);
      if (error.response && error.response.status === 403) {
        setSecondMessage("You are member! Please use mobile app to pay.");
      }
    } finally {
      setLoader(false);
    }
  };

  const handleRazorpayPayment = (RazorpayOrderId, amount) => {
    const adjustedAmount = amount * 100;

    const form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute("action", "https://api.razorpay.com/v1/checkout/embedded");
    // form.setAttribute("target", "_blank");

    const fields = [
      { name: "key_id", value: `${process.env.REACT_APP_RAZORPAY_ID}` },
      { name: "order_id", value: RazorpayOrderId },
      { name: "amount", value: adjustedAmount },
      { name: "currency", value: "INR" },
      { name: "name", value: "Net Gala" },
      { name: "description", value: "Please complete your payment to proceed." },
      { name: "image", value: `${process.env.REACT_APP_HOSTED_URL}/logo.png` },
      { name: "callback_url", value: `${process.env.REACT_APP_BASE_URL}/payment/callback/` },
      { name: "cancel_url", value: `${process.env.REACT_APP_BASE_URL}/payment/cancel` },
      { name: "prefill[name]", value: FirstName },
      { name: "prefill[contact]", value: MobileNumber },
      { name: "prefill[email]", value: EmailAddress || "" },
    ];

    fields.forEach(({ name, value }) => {
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", name);
      input.setAttribute("value", value);
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  };

  const handleRetry = () => {
    setStep(1);
    setMobile("");
    setOtp("");
    setMessage("");
    setSecondMessage("");
    setShowRetry(false);
    setDisableVerifyBtn(false);
  };

  const today = new Date();
  const startOfDay = `${today.getFullYear()}-${(today.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}T00:00:00`;


  // Fetch data from the backend when the component is mounted
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await Axios.get(`${process.env.REACT_APP_BASE_URL}/events/?limit=100`);

        // Filter events whose EndTimeStamp is greater than today's date
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Set time to start of day
        console.log('today', today)
        const allEvents = res.data.events.filter(event => {
          const endTimeStamp = new Date(event.EventSchedule.EndTimeStamp);
          endTimeStamp.setHours(0, 0, 0, 0); // Set time to start of day
          console.log('endTimeStamp', endTimeStamp)
          return endTimeStamp >= today;
        });
 

        const filteredData = allEvents.filter(event => event.EventId === eventId)[0]
        const moreEvents = allEvents.filter(event => event.EventId !== eventId)
        setMoreEvent(moreEvents);
        setEventData(filteredData); // Set event data from response

        const data = filteredData;


        // Fetching image data

        //SquareImg
        const squareImg = data.EventImages.find((image) => image.Tags.includes("SQUARE"));
        const squareImgFileId = squareImg ? squareImg.FileId : null;

        //WideImag
        const wideImg = data.EventImages.find((image) => image.Tags.includes("WIDE"));
        const wideImgFileId = wideImg ? wideImg.FileId : null;

        if (!squareImgFileId && squareImgFileId === null) {
          console.error("No square image is found for the event", data.EventTitle)
        }

        if (!wideImgFileId && wideImgFileId === null) {
          console.error("No wide image is found for the event", data.EventTitle)
        }

        try {
          if (squareImgFileId) {
            const responseSquare = await Axios.get(
              `${process.env.REACT_APP_BASE_URL}/files/${squareImgFileId}/download`,
              {
                responseType: "blob",
              }
            );


            const imageObjectURL = URL.createObjectURL(responseSquare.data);
            setImageUrlSquare(imageObjectURL);
          }

          if (wideImgFileId) {
            const responseWide = await Axios.get(`${process.env.REACT_APP_BASE_URL}/files/${wideImgFileId}/download`,
              {
                responseType: "blob",
              }
            );
            const imageObjectURLWide = URL.createObjectURL(responseWide.data);
            setImageUrlWide(imageObjectURLWide);

          }


        } catch (imageError) {
          console.error('Error fetching image: ', imageError)
          setImageUrlSquare("");
        }


        // Extract and format all relevant dates
        if (data.EventSchedule) {
          const startDate = format(new Date(data.EventSchedule.StartTimeStamp), "do MMMM");
          const endDate = format(new Date(data.EventSchedule.EndTimeStamp), "do MMMM");
          const registrationStartDate = format(new Date(data.EventSchedule.RegistrationStartTimeStamp), "dd MMM, EEEE yyyy");
          const registrationEndDate = format(new Date(data.EventSchedule.RegistrationEndTimeStamp), "dd MMM, EEEE yyyy");
          const StartTimeStamp = format(new Date(data.EventSchedule.StartTimeStamp), "h:mm a");
          const EndTimeStamp = format(new Date(data.EventSchedule.EndTimeStamp), "h:mm a");


          // Store formatted dates in state
          setFormattedDates({
            startDate,
            endDate,
            registrationStartDate,
            registrationEndDate,
            StartTimeStamp,
            EndTimeStamp
          });
        }
        setLoading(false); // Stop loading

      } catch (error) {
        setError(error.message);
        console.error("Error fetching data or images:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [eventId]);




  //Defining size of badge for the current event
  const BadgeSize = { width: '18rem', height: '18rem' };



  if (error) {

    return (
      <div className="w-full h-[100vh] flex justify-center items-center">
        <p>Error loading data... {error.message}</p>

      </div>

    ) // Show error message
  }




  return (
    <>
      <Header />
      {loading ? (
        <div className="w-full h-[100vh] flex justify-center items-center">
          <ClipLoader size={50} color={"#2D1066"} loading={loading} />
        </div >
      ) : (
        <>

        {/* Rest of the current events card here */}
        <div className="flex flex-col md:flex-row w-full pb-14 pt-32">
          {/* Upper Part Event Details */}
          <div className="event-details flex flex-col justify-between items-center md:items-start md:w-[65%] gap-6 ">
            {/* Left Side Event card here  */}
            <div className="   flex flex-col md:flex-row justify-center md:items-start items-center w-full">
              {/* Card Div */}
              <div className="event-card-left w-[95%] rounded-3xl  md:pl-12 md:py-8  md:ml-auto flex flex-col md:flex-row md:gap-10 justify-between items-center md:items-start p-4 relative">
                {/* Left Image */}
                <div className="align-middle  md:w-[33%] md:py-6 w-full ">
                  {imageUrlSquare ? (
                    <img
                      className=" hidden md:block w-full  mx-auto rounded-3xl"
                      src={imageUrlSquare}
                      alt={eventData.EventTitle}
                    />
                  ) : ""}
                  {imageUrlWide ? (
                    <img
                      className=" md:hidden w-full h-[12rem] mt-2 rounded-3xl"
                      src={imageUrlWide}
                      alt={eventData.EventTitle}
                    />
                  ) : ""}
                </div>

                {/* Center Text */}
                <section className="written-and-logo flex md:justify-between md:py-6  w-full ">
                  <div className="flex flex-col justify-start md:gap-y-3 gap-6  items-start md:w-[60%] py-5 md:py-0 text-[var(--medium-purple)] overflow-hidden ">
                    <div className="mobile-flex-view flex md:block items-center ">
                      <span className="xl:text-4xl 2xl:text-5xl lg:text-3xl md:text-2xl text-[1.75rem] font-semibold md:mb-10 font-[manrope] w-[80%] md:w-auto">
                        {eventData.EventTitle}
                      </span>
                      <div className=" md:hidden w-[38%] absolute left-[14.2rem] top-[12rem]">
                        <BadgeImage EventType={eventData.EventType} size={BadgeSize} />
                      </div>
                    </div>

                    <span id="scroll-container" className="font-medium md:text-sm lg:text-base md:max-h-16 text-base font-ClashGrotesk max-h-24 lg:max-h-20 xl:max-h-28 overflow-y-auto "
                      
                    >
                      <ReactMarkdown
                        children={
                          eventData.EventDescription || "No description provided."
                        }
                        remarkPlugins={[remarkGfm]}
                        rehypePlugins={[rehypeRaw]}
                        components={{
                          a: ({ children, href }) => (
                            <a href={href} className="hover:text-blue-500 underline">
                              {children}
                            </a>
                          ),
                          ul: ({ children }) => (
                            <ul className="list-disc pl-5">{children}</ul>
                          ),
                          ol: ({children})=>(
                            <ol className="list-decimal pl-5" >{children}</ol>
                          ),
                        }}
                      />

                    </span>
                  </div>

                  {/* Right league badge image */}
                  <div className="md:w-[38%]  align-middle md:block hidden -mt-10 -ml-16">
                    {/* <img className="ml-0 md:w-full" src={leagueBadge} alt="League Badge" /> */}
                    <BadgeImage EventType={eventData.EventType} size={BadgeSize} />
                  </div>
                </section>
              </div>
            </div>

            {/* Right side payment card for mobile only view here*/}
            <div className="current-event-right-portion w-[95%] md:w-2/5 md:hidden  flex justify-center items-start ">
              {/* Card Div */}
              <div className="amount-card-right md:w-[75%] w-full bg-[var(--white)] rounded-2xl sticky top-0 flex flex-col  p-6 gap-4">
                {/* Event Title */}
                <h3 className="text-2xl font-ClashGrotesk font-medium text-[var(--dark-blue)] text-left">
                  {eventData.EventTitle} x 1
                </h3>
                
                {/* Total Amount */}
                <div className="text-left">
                  <p className="text-xl font-manrope font-semibold text-[var(--medium-purple)] mb-1">Total Amount: ₹{(eventData.Price ?? 0)}</p>
                </div>            
                <button
                  onClick={() => setShowPaymentModal(true)}
                  className="w-full py-3 rounded-xl font-manrope text-lg bg-[var(--purple-blue)] text-[var(--white)] transition-colors duration-300 ease-in-out hover:bg-[var(--medium-purple)]"
                >
                  Proceed to payment
                </button>
              </div>
            </div>

            {/* Event Details go here */}
            <div className="para mt-10 md:p-8 md:pr-0 w-full  ">
              <div className="flex flex-col gap-6 2xl:gap-8 w-full text-[var(--dark-blue)] ">
                {/* Event Details Heading */}
                <div className="flex flex-col md:flex-row  w-full p-4 gap-3 md:gap-6 ">
                  <div className="md:w-1/3 md:text-[2rem] text-[1.75rem] font-medium font-ClashGrotesk">
                    Event Details
                  </div>
                  <div className="md:w-2/3 flex flex-col justify-between items-start text-[var(--medium-black)] text-xl  font-manrope font-[630]">
                    <span className="pl-2 flex gap-1 py-2 md:py-1">
                      {" "}
                      <span className="mt-1"><img src={calendarVector} alt="calendar" /></span>

                      {formattedDates.startDate}
                      {formattedDates.endDate > formattedDates.startDate ? ` - ${formattedDates.endDate}` : ''}


                    </span>
                    <hr className="text-base  border border-solid border-[var(--dull-white)] w-[90%] md:w-full my-2 border-opacity-40 hidden md:block" />
                    <span className="pl-2 flex gap-1 py-2 md:py-1">
                      {" "}
                      <span className="mt-1"><img src={timeVector} alt="clock" /></span>
                      {formattedDates.StartTimeStamp} - {formattedDates.EndTimeStamp}
                    </span>
                    <hr className="text-base border border-solid border-[var(--dull-white)] w-[90%] md:w-full my-2 border-opacity-40 hidden md:block" />
                    <span className="pl-2 flex gap-1 py-2 md:py-1">
                      {" "}
                      <span className="mt-1"><img src={locationVector} alt="location" /></span>
                      {" "}
                      {eventData?.venue.VenueName},{" "}
                      {eventData?.venue.VenueAddress.city}
                    </span>
                    <hr className="text-base border border-solid border-[var(--dull-white)] w-[90%] md:w-full my-2 border-opacity-40 hidden md:block" />
                  </div>
                </div>

                {/* About one day tournaments heading */}
                <div className="flex flex-col md:flex-row gap-3 md:gap-6  p-4">
                  <div className="md:w-1/3 md:text-[2rem] text-[1.75rem]   font-medium font-ClashGrotesk">
                    About
                  </div>
                  <div className="md:w-2/3 flex flex-col justify-between items-start text-xl  font-manrope font-medium">
                    <span
                    // dangerouslySetInnerHTML={{ __html: marked(eventData.About) }}
                    >

                      <ReactMarkdown
                        children={
                          eventData?.About || "No description provided."
                        }
                        remarkPlugins={[remarkGfm]}
                        rehypePlugins={[rehypeRaw]}
                        components={{
                          a: ({ children, href }) => (
                            <a href={href} className="hover:text-blue-500 underline">
                              {children}
                            </a>
                          ),
                          ul: ({ children }) => (
                            <ul className="list-disc pl-5">{children}</ul>
                          ),
                          ol: ({children})=>(
                            <ol className="list-decimal pl-5" >{children}</ol>
                          ),
                        }}
                      />


                    </span>
                  </div>
                </div>

                {/* About the sponsors */}
                {eventData?.sponsors?.length > 0 && (
                  <div className="flex flex-col md:flex-row gap-3 md:gap-6 2xl:gap-6 p-4 md:items-center">
                    <div className="md:w-1/3 text-[1.75rem] md:text-[2rem] font-medium font-ClashGrotesk">
                      Sponsors
                    </div>
                    <div className="md:w-2/3 flex justify-between items-start text-xl font-manrope font-medium">
                      <ShowSponsors eventData={eventData} />
                    </div>
                  </div>
                )}

                {/* Location Link */}
                <div className="flex flex-col md:flex-row gap-3 md:gap-6 2xl:gap-6 p-4">
                  <div className="md:w-1/3 md:text-[2rem] text-[1.75rem] font-medium font-ClashGrotesk">
                    Location Link
                  </div>
                  <div className="md:w-2/3 flex flex-col justify-between items-start text-xl  text-[var(--medium-black)] underline font-manrope font-semibold">
                    <span>
                      <a
                        className="flex gap-1 "
                        target="_blank" rel="noreferrer"
                        href={eventData.venue.MapLink}
                      >
                        {" "}
                        <img src={linkVector} alt="link vector" /> {eventData?.venue.VenueName},{" "}
                        {eventData?.venue.VenueAddress.city}
                      </a>
                    </span>
                  </div>
                </div>

                {/* Event FAQs */}
                {eventData?.FAQ[0]?.question.length>0 && eventData?.FAQ[0].answer.length>0 ? (
                  <div className="flex flex-col md:flex-row gap-3 md:gap-6  p-4">
                    <div className="md:w-1/3 md:text-[2rem] text-[1.75rem]  font-medium font-ClashGrotesk">
                      Event FAQs
                    </div>
                    <div className="md:w-2/3 flex flex-col justify-between items-start text-base 2xl:text-xl font-manrope font-semibold ">
                      <AccordianFaq eventData={eventData} />
                    </div>
                  </div>
                ) : ('')}

              </div>
            </div>
          </div>

          {/* Right side payment card  here for medium and above devices view*/}
          <div className="current-event-right-portion w-[90%] md:w-[35%] hidden md:flex justify-center items-start">
            {/* Card Div */}
            <div className="amount-card-right md:w-[80%] w-full bg-[var(--white)] rounded-2xl sticky top-[7.5rem] flex flex-col  py-6 gap-3 px-4">
              {/* Event Title */}
              <h3 className="text-2xl font-ClashGrotesk font-medium text-[var(--dark-blue)] text-left ">
                {eventData.EventTitle} x 1
              </h3>
              
              {/* Total Amount */}
              <div className="text-left">
                <p className="text-xl font-manrope font-semibold text-[var(--medium-purple)] mb-2">Total Amount: ₹{(eventData.Price ?? 0)}</p>
              </div>
              
              <button
                onClick={() => setShowPaymentModal(true)}
                className="w-[90%] py-3 rounded-xl font-manrope text-lg bg-[var(--purple-blue)] text-[var(--white)] transition-colors duration-300 ease-in-out hover:bg-[var(--medium-purple)] mx-auto"
              >
                Proceed to payment
              </button>
            </div>
          </div>
        </div>


        <MoreEvents eventData={moreEvents} sliceTill={2} />

        {/* Payment Modal */}
        {showPaymentModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-2xl p-6 w-[90%] max-w-md mx-4">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-2xl font-ClashGrotesk font-medium text-[var(--dark-blue)]">
                  Complete Payment
                </h3>
                <button
                  onClick={() => setShowPaymentModal(false)}
                  className="bg-white text-gray-500 hover:text-gray-700 text-2xl"
                >
                  ×
                </button>
              </div>

              {step === 1 && (
                <div className="space-y-4">
                  <div>
                    <label className="block text-base font-manrope font-semibold text-[var(--medium-purple)] mb-2">
                      Mobile Number
                    </label>
                    <input
                      type="tel"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      placeholder="Enter your mobile number"
                      className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:outline-none focus:border-[var(--medium-purple)]"
                    />
                  </div>
                  {message && (
                    <p className="text-sm text-center text-[var(--medium-purple)]">{message}</p>
                  )}
                  <button
                    onClick={sendOtp}
                    disabled={!mobile || loader}
                    className="w-full py-3 rounded-xl font-manrope text-lg bg-[var(--purple-blue)] text-white disabled:bg-gray-400 transition-colors duration-300"
                  >
                    {loader ? <ClipLoader color="white" size={20} /> : "Send OTP"}
                  </button>
                </div>
              )}

              {step === 2 && (
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-manrope text-[var(--medium-purple)] mb-2">
                      Enter OTP
                    </label>
                    <input
                      type="text"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      placeholder="Enter 6-digit OTP"
                      className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:outline-none focus:border-[var(--medium-purple)]"
                    />
                  </div>
                  {message && (
                    <p className="text-sm text-center text-[var(--medium-purple)]">{message}</p>
                  )}
                  {secondMessage && (
                    <p className="text-sm text-center text-[var(--dark-blue)]">{secondMessage}</p>
                  )}
                  
                  <button
                    onClick={verifyOtp}
                    disabled={!otp || loader || disableVerifyBtn}
                    className="w-full py-3 rounded-xl font-manrope text-lg bg-[var(--purple-blue)] text-white disabled:bg-gray-400 transition-colors duration-300"
                  >
                    {loader ? <ClipLoader color="white" size={20} /> : "Verify & Pay"}
                  </button>
                  {showRetry && (
                    <button
                      onClick={handleRetry}
                      className="w-full py-2 rounded-xl font-manrope text-lg bg-gray-200 text-[var(--dark-blue)] mb-2"
                    >
                      Retry 
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
        </>
      )}
      <Footer />
    </>
  );
};
export default OrderPaymentEventPage;
